export const CoreDataDictionaryViewsSharedKeyName = 'CoreDataDictionaryViewsSharedKey';
